<template>
  <div style="padding:10px 12px">
    <img src="https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/MEHZ/images/meet1.png" alt="" style="width:100%;height:150px;margin:0 auto;">

    <div style="margin-top:20px;">绑定信息</div>
    <!-- <a-form-model ref="ruleForm" :model="form" :rules="rules">
      <a-form-model-item style="margin-bottom:10px;" prop='name'>
        <a-input v-model="form.name" placeholder="请输入姓名" />
      </a-form-model-item>
      <a-form-model-item prop='phone'>
        <a-input v-model="form.phone" placeholder="请输入手机号" />
      </a-form-model-item>

      <a-form-model-item>
        <a-button type="primary" style="width:100%;height:40px;" @click="onSubmit">
          提交绑定信息
        </a-button>
      </a-form-model-item>

    </a-form-model> -->

    <van-form @submit="onSubmit">

      <van-field v-model="form.name" placeholder="请输入姓名" label="姓名" :rules="[{ required: true, message: '请输入姓名' }]">
      </van-field>

      <van-field v-model="form.phone" placeholder="请输入手机号" label="手机号" :rules="[{ required: true, message: '请输入手机号' }]"></van-field>

      <div style="margin: 16px;">
        <van-button round block type="info" native-type="submit">提交</van-button>
      </div>

    </van-form>

  </div>
</template>

<style lang="less" scoped>
ul {
  margin: 0;
  padding: 0;
  li {
    line-height: 25px;
    margin: 0;
    padding: 0;
    list-style: none;
  }
}
</style>
<script>
import { bindAccount } from '@/api/mehzShop'
// import { mapState } from 'vuex'
import { getQueryStringBySearch } from '@/utils/utils'
export default {
  computed: {},
  mounted() {
    this.token = getQueryStringBySearch(location.search, 'access_token')
    let name = getQueryStringBySearch(location.search, 'shopName')

    localStorage.setItem('access_token', this.token)
    localStorage.setItem('shopName', name)
  },
  methods: {
    onSubmit() {
      var headerClientInfo = { language: 'CN', eventKey: 'MEHZ', appKey: 'WX_MINI_MEHZ' }
      let headers = {
        'x-call-client-info': JSON.stringify(headerClientInfo),
        token: this.token,
      }
      bindAccount(headers, this.form).then((res) => {
        console.log(res)
        this.$toast.success('绑定成功')
        setTimeout(() => {
          this.$router.push({ path: '/mehz/shopCheck' })
        }, 1500)
      })
      // this.$message.success('绑定成功')
      // setTimeout(() => {
      //   this.$router.push({ path: '/mehzIndex' })
      // }, 1500)
    },
  },
  data() {
    return {
      list: [],
      token: '',
      form: {
        name: '',
        phone: '',
      },
      rules: {
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        phone: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
      },
    }
  },
}
</script>

<style>
</style>